import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { sortableContainer, sortableElement } from 'react-sortable-hoc';

import QuestionItem from "./QuestionItem/QuestionItem";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";
import Tabs from "../../ui/Tabs/Tabs";
import PaginationBlock from "../../ui/PaginationBlock/PaginationBlock";

import {
  getQuestionsListAsync,
  switchQuestionsFilter,
  goToQuestionCreation,
  sortQuestionsAsync,
  changeQuestionsPage,
  changeQuestionsLimit,
} from "../../../redux/actions/questionsList";

import { getQuestionsCountAsync } from "../../../redux/actions/ui";

const mapStateToProps = state => ({
  ...state.questionsList,
  countForClients: state.ui.countForClients,
  countForConsultants: state.ui.countForConsultants,
});

const mapDispatchToProps = dispatch => ({
  createQuestion: () => dispatch(goToQuestionCreation()),
  getQuestionsList: payload => dispatch(getQuestionsListAsync(payload)),
  switchTab: tab => dispatch(switchQuestionsFilter(tab)),
  onSortQuestions: ({oldIndex, newIndex}) => dispatch(sortQuestionsAsync({oldIndex, newIndex})),
  onChangePage: page => dispatch(changeQuestionsPage(page)),
  onChangeDisplayOption: limit => dispatch(changeQuestionsLimit(limit)),
  getQuestionsCount: () => dispatch(getQuestionsCountAsync()),
});

const SortableItem = sortableElement(({question}) => (
  <QuestionItem
    key={`${question.id}_${question.index}`}
    question={question}
  />
));

const SortableContainer = sortableContainer(({children}) => {
  return <div className="list-items-content">{children}</div>;
});

const tabs = [ 
  { name: 'Клиенты', value: 0, role: 'client', filter: 'visible' },
  { name: 'Консультанты', value: 1, role: 'consultant', filter: 'visible' },
  { name: 'Архив', value: 2, role: null, filter: 'hidden' },
];

class QuestionsList extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    total: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    activePage: PropTypes.number.isRequired,
    updated: PropTypes.bool.isRequired, //Нужно ли?
    questions: PropTypes.array.isRequired,
    filters: PropTypes.object.isRequired,
    createQuestion: PropTypes.func.isRequired,
    getQuestionsList: PropTypes.func.isRequired,
    switchTab: PropTypes.func.isRequired,
    onSortQuestions: PropTypes.func.isRequired,
    onChangePage: PropTypes.func.isRequired,
    onChangeDisplayOption: PropTypes.func.isRequired,
    //Количество уже созданных вопросов разных типов
    getQuestionsCount: PropTypes.func.isRequired,
    countForClients: PropTypes.number.isRequired,
    countForConsultants: PropTypes.number.isRequired,
  };

  componentDidMount = () => { 
    const { getQuestionsList, getQuestionsCount } = this.props;
    const payload = this.setPayload();
    getQuestionsList(payload);
    //Получение количества вопросов для клиентов и консультантов
    getQuestionsCount();
  }

  //Пагинация и фильтры
  componentDidUpdate = previousProps => {
    const { limit, activePage, updated, filters, getQuestionsList, getQuestionsCount } = this.props;
    const payload = this.setPayload();

    //Условия перезагрузки
    //Не прописали отдельно role и filter, т.к. они обновятся вместе с табом
    if ((previousProps.filters.activeTab !== filters.activeTab)
      //Пагинация
      || ((previousProps.activePage !== activePage) && (filters.filter === 'hidden'))
      || ((previousProps.limit !== limit) && (filters.filter === 'hidden'))
    ) getQuestionsList(payload);

    if ((previousProps.updated !== updated) && (updated === true)){
      getQuestionsList(payload);
      getQuestionsCount();
    } 

  }

  setPayload = () => {
    const { filters, limit, activePage } = this.props;
    //filters.role - роль пользователя, по которой происходит фильтрация
    //filters.filter - visible или hidden 
    //Для таба 2 с видимостью hidden есть пагинация
    const payload = { filter: filters.filter };
    if (filters.role !== null) payload.role = filters.role;
    if (filters.filter === 'hidden') {
      payload.limit = limit;
      payload.page = activePage;
    }
    return payload;
  }

  //Список вопросов с возможностью drag and drop
  renderQuestionsList = (question, i) => {
    question.index = i;
    return(
      <SortableItem key={`item-${question.id}`} index={i} question={question} />
    );
  }

  render() {
    const {
      ready,
      loading,
      total,
      limit,
      activePage,
      questions,
      filters,
      switchTab,
      onSortQuestions,
      onChangePage,
      onChangeDisplayOption,
      createQuestion,
      countForClients,
      countForConsultants,
    } = this.props;

    //Рассчитаем количество страниц пагинации
    const pagesCount = Math.ceil(total / limit);

    //Определим, не является ли кнопка "Создать вопрос" неактивной для этого таба
    //Проверка на 2 активных табах
    let isDisabled = false;

    if ((countForClients >= 5) && (countForConsultants >= 5)) isDisabled = true;

    return (
      <div className="list-items-wrap">
        <div className="list-items-header msg-wrap">
          <button
            type="button"
            className="btn btn-green"
            style={{width: '206px'}}
            disabled={isDisabled}
            onClick={() => createQuestion()}
          >
            Создать вопрос
          </button>
          {isDisabled ? (
            <div className="btn-msg">Достигнут лимит создания вопросов. Максимум 5 активных вопросов для каждой роли </div>
          ) : false}
        </div>
        {/* Табы - переключатели */}
        <Tabs 
          tabs={tabs}
          activeTab={filters.activeTab}
          onClickTab={switchTab}
        />
        {ready ? (
          <React.Fragment>
            <SortableContainer
              useDragHandle
              helperClass="isDragged"
              onSortEnd={onSortQuestions}
            >
              {questions.map(this.renderQuestionsList)}
            </SortableContainer>
            {filters.filter === 'hidden' ? (
              <div className="list-items-footer">
                <PaginationBlock
                  activePage={activePage}
                  pagesCount={pagesCount}
                  pagesVisible={7}
                  onChangePage={onChangePage}
                  displayOptions={[10, 20, 40, 80]}
                  selectedDisplayOption={limit}
                  selectDisplayOption={onChangeDisplayOption}
                />
              </div>
            ) : false}
          </React.Fragment>
        ) : false}
        {loading ? (<Spinner />) : false}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(QuestionsList));
